import React, { Component } from 'react';
import {Route} from "react-router-dom";
import {withStyles} from "@material-ui/styles";
import {Spinner} from "../common/Spinner";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import GridItem from "../common/dashboard/GridItem.js";
import Card from "../common/dashboard/Card.js";
import CardBody from "../common/dashboard/CardBody.js";
import CardHeader from "../common/dashboard/CardHeader.js";
import CardIcon from "../common/dashboard/CardIcon.js";
import {NotificationContainer} from "react-notifications";
import CardMui from "@material-ui/core/Card";
import {AccessTime} from "@material-ui/icons";
import CardFooter from "../common/dashboard/CardFooter";
import CustomerComplaints from "./CustomerComplaints";
import CustomerNumbers from "./CustomerNumbers";
import CorrectiveActions from "./CorrectiveActions";
import dashboardStyle from "../common/dashboard/dashboardStyle.js";
import {GreenButton} from "../common/ButtonsConstants";
import * as CommonUtils from "../../util/CommonUtils";
import { t } from '../../i18n';

const classes = (() => ({
    ...dashboardStyle,
    root: {
        width: '100%',
        overflowX: 'auto',
        padding: '30px',
    },
}));

class Leadership extends Component {

    constructor(props) {
        super(props);
        this.state = {
            latestRevision: {},
            isLoading: true,
            isEditCustomerComplaints: false,
            isEditCustomerNumbers: false,
            isEditActions: false,
            complaintsButtonLabel: t('leadership.customize'),
            customerNumbersButtonLabel: t('leadership.customize'),
            actionsButtonLabel: t('leadership.customize'),
        };
        this.editCustomerComplaints = this.editCustomerComplaints.bind(this);
        this.editCustomerNumbers = this.editCustomerNumbers.bind(this);
        this.editActions = this.editActions.bind(this);
        this.onChanged = this.onChanged.bind(this);
    }

    onChanged(customerComplaints) {
        console.log(customerComplaints);
    }

    editCustomerComplaints() {
        if (!this.canEdit()) {
            return false;
        }
        console.log('this.state.isEditCustomerComplaints', this.state.isEditCustomerComplaints);
        let newVal = !this.state.isEditCustomerComplaints;
        this.setState({
            isEditCustomerComplaints: newVal,
            complaintsButtonLabel: newVal ? t('leadership.redraw') : t('leadership.customize')
        });
        return false;
    }

    editCustomerNumbers() {
        if (!this.canEdit()) {
            return false;
        }
        let newVal = !this.state.isEditCustomerNumbers;
        this.setState({
            isEditCustomerNumbers: newVal,
            customerNumbersButtonLabel: newVal ? t('leadership.redraw') : t('leadership.customize')
        });
        return false;
    }

    editActions() {
        if (!this.canEdit()) {
            return false;
        }
        let newVal = !this.state.isEditActions;
        this.setState({
            isEditActions: newVal,
            actionsButtonLabel: newVal ? t('leadership.redraw') : t('leadership.customize')
        });
        return false;
    }

    canEdit() {
        return !CommonUtils.isAuditor(this.props.currentUser) && !CommonUtils.isViewer(this.props.currentUser);
    }

    render() {
        let { state } = this;
        const { classes } = this.props;
        let canEdit = this.canEdit();
        return <div className="mui-container-fluid">
            <Route path={`/leadership` }>
                <CardMui className={classes.card}>
                        <hr/>
                        <Paper className={classes.root}>
                            <Typography component="h2" variant="h5">
                                <span style={{color: "darkblue"}}>
                                    <p><b>{ t('leadership.title') }</b></p>
                                </span>
                            </Typography>
                            <Grid container>
                                <GridItem xs={12} sm={12} md={6}>
                                    <Card chart>
                                        <CardBody>
                                            <p className={classes.cardCategory} style={{ float: "right" }}><GreenButton disabled={!canEdit} onClick={this.editCustomerComplaints} type="submit">{this.state.complaintsButtonLabel}</GreenButton></p>
                                            <h3 className={classes.cardTitle}>{ t('menu.leadership.customerComplaints') }</h3>
                                        </CardBody>
                                        <CardHeader>
                                            <CustomerComplaints isEdit={canEdit && this.state.isEditCustomerComplaints} onChanged={this.onChanged} currentUser={this.props.currentUser}/>
                                        </CardHeader>
                                        <CardFooter chart>
                                            <div className={classes.stats}>
                                                <AccessTime /> { t('leadership.generated') } {new Date().toLocaleDateString()}
                                            </div>
                                        </CardFooter>
                                    </Card>
                                </GridItem>
                                <GridItem xs={12} sm={12} md={6}>
                                    <Card chart>
                                        <CardBody>
                                            <p className={classes.cardCategory} style={{ float: "right" }}><GreenButton disabled={!canEdit} onClick={this.editActions} type="submit">{this.state.actionsButtonLabel}</GreenButton></p>
                                            <h3 className={classes.cardTitle}>{ t('leadership.nonconformance') }</h3>
                                        </CardBody>
                                        <CardHeader>
                                            <CorrectiveActions isEdit={canEdit && this.state.isEditActions} onChanged={this.onChanged} currentUser={this.props.currentUser}/>
                                        </CardHeader>
                                        <CardFooter chart>
                                            <div className={classes.stats}>
                                                <AccessTime /> { t('leadership.generated') } {new Date().toLocaleDateString()}
                                            </div>
                                        </CardFooter>
                                    </Card>
                                </GridItem>
                            </Grid>
                            <Grid container>
                                <GridItem xs={12} sm={12} md={6}>
                                    <Card chart>
                                        <CardBody>
                                            <p className={classes.cardCategory} style={{ float: "right" }}><GreenButton disabled={!canEdit} onClick={this.editCustomerNumbers} type="submit">{this.state.customerNumbersButtonLabel}</GreenButton></p>
                                            <h3 className={classes.cardTitle}>{ t('leadership.customersNumbers') }</h3>
                                        </CardBody>
                                        <CardHeader>
                                            <CustomerNumbers isEdit={canEdit && this.state.isEditCustomerNumbers} onChanged={this.onChanged} currentUser={this.props.currentUser}/>
                                        </CardHeader>
                                        <CardFooter chart>
                                            <div className={classes.stats}>
                                                <AccessTime /> { t('leadership.generated') } {new Date().toLocaleDateString()}
                                            </div>
                                        </CardFooter>
                                    </Card>
                                </GridItem>
                            </Grid>
                            {/*<Grid>
                                <GridItem xs={12} sm={12} md={6}>
                                    <Card>
                                        <CardHeader color="rose" icon>
                                            <CardIcon color="rose">
                                                <Language />
                                            </CardIcon>
                                        </CardHeader>
                                        <CardBody>
                                            <h4 className={classes.cardTitle}>{ t('leadership.iconTitle') }</h4>
                                            { t('leadership.iconDescription') }
                                        </CardBody>
                                    </Card>
                                </GridItem>
                            </Grid>*/}
                            <NotificationContainer/>
                        </Paper>
                </CardMui>
            </Route>
        </div>;
    }
}

export default withStyles(classes)(Leadership);
